import { render, staticRenderFns } from "./rentabilidade.vue?vue&type=template&id=7695bab2&scoped=true&"
import script from "./rentabilidade.vue?vue&type=script&lang=js&"
export * from "./rentabilidade.vue?vue&type=script&lang=js&"
import style0 from "./rentabilidade.vue?vue&type=style&index=0&id=7695bab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695bab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VSwitch})
